import * as React from 'react'

import { Box, Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type ClockPicture from 'modules/employees/store/models/ClockPicture'

import Body from './_Body'
import Filter from './_Filter'
import { STATUS } from './constants'
import { filterClockPictures } from './filtering'
import { ClockPicturesConfigFilters } from './forms'

type FilterProps = React.ComponentProps<typeof Filter>

interface Props {
  clockPictures: ClockPicture[]
  employeeFullName: string
}

const ClockPicturesTable = ({ clockPictures, employeeFullName }: Props) => {
  const [status, setStatus] = React.useState<string>(STATUS.allPictures)
  const filteredClockPictures = filterClockPictures(clockPictures, status)
  const onFilterStatus: FilterProps['onFilterStatus'] = (newStatus) => setStatus(newStatus)

  const filtersForm = new ClockPicturesConfigFilters({
    status: status,
  })

  const tableOptions = () => (
    <Box flexDirection="row" gap="s8" flexGrow alignItems="center">
      <Filter filtersForm={filtersForm} onFilterStatus={onFilterStatus} />
    </Box>
  )

  return (
    <Table options={tableOptions} fullWidth>
      <Body clockPictures={filteredClockPictures} employeeFullName={employeeFullName} />
    </Table>
  )
}

export default observer(ClockPicturesTable)
